import React from 'react';
import { Grid } from '@mui/material';

import ContactsTable from 'app/main/modules/components/ContactsTable';
import PhonesListItem from 'app/main/submodules/phones/PhonesListItem';
import MailsListItem from 'app/main/submodules/mails/MailsListItem';
import SocialNetworksListItem from 'app/main/submodules/socialnetworks/SocialNetworksListItem';

export default function UsersContactTab({ itemUid }: { itemUid: string }) {
	return (
		<Grid container spacing={2}>
			<Grid size={{ md: 4, xs: 12 }}>
				<ContactsTable
					contactModule="phones"
					parentModule="users"
					parentUid={itemUid}
					itemLayout={PhonesListItem}
				/>
			</Grid>
			<Grid size={{ md: 4, xs: 12 }}>
				<ContactsTable
					contactModule="mails"
					parentModule="users"
					parentUid={itemUid}
					itemLayout={MailsListItem}
				/>
			</Grid>
			<Grid size={{ md: 4, xs: 12 }}>
				<ContactsTable
					contactModule="socialnetworks"
					parentModule="users"
					parentUid={itemUid}
					itemLayout={SocialNetworksListItem}
				/>
			</Grid>
		</Grid>
	);
}
